<template>
<div class="mall-solution">
  <div class="content">
    <h2>热门解决方案</h2>
    <p>消费场景、政府场景、工业场景，都有完整的解决方案<a href="javascript:;" @click="goAll">查看全部 ></a></p>
    <div class="list-box">
      <div
          class="card"
          v-for="el in solutionList"
          :key="el.id"
          @click="solutionInfo(el.id, el.hotType)"
      >
        <div>
          <div class="text-overflow title">{{el.name}}<img v-if="el.marketing === 2" src="@/assets/img/2.0/mall/tuijian.png" alt=""></div>
          <div class="tags">
            <span class="text-overflow" v-for="(item, index) in el.tag" :key="index">{{item}}</span>
          </div>
          <p class="text-overflow2"> {{ el.solutionDiscription }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {getSolutionList} from '@/api/solution.js'

export default {
  name: "mallSolution",
  data(){
    return{
      page: {
        current: 1,
        size: 6,
        total: 0,
      },
      solutionList:[]
    }
  },
  methods:{
    // 解决方案列表
    loadGetSolutionList() {
      let { page } = this;

      getSolutionList(page, {}).then((res) => {
        this.solutionList = res.records;

        this.solutionList.forEach((item) => {
          if (item.tag) {
            item.tag = item.tag.split(",").slice(0, 3);
          }
        });
        this.page.total = res.total;
      });
    },
    solutionInfo(id, type) {
      // type  1 常规方案，2 3 鸿蒙方案， 4 小红书方案 5 普通方案 6数字方案
      // 1 ， 2 3，4 5，6
      if (type == 2 || type == 3) {
        this.$router.push({
          path: "/solution/info",
          query: { id },
        });
      } else if (type == 1) {
        this.$router.push({
          path: "/solution/internet_things",
          query: { id },
        });
      } else if (type == 4 || type == 5) {
        this.$router.push({
          path: "/solution/ordinary_program",
          query: { id },
        });
      } else if (type == 6) {
        this.$router.push({
          path: "/solution/digitizing",
          query: { id },
        });
      }
    },
    goAll(){
      this.$router.push('/solution')
    },
  },
  mounted() {
    this.loadGetSolutionList()
  }
}
</script>


<style scoped lang="scss">
.mall-solution{
  background: #FFFFFF;
  .content{
    width: 1280px;
    margin: 0 auto;
    padding: 64px 0 74px;
    display: flex;
    flex-direction: column;
    align-items: center;
    >h2{
      font-weight: 600;
      font-size: 32px;
      color: #262626;
      line-height: 45px;
      margin-bottom: 16px;
    }
    >P{
      font-weight: 400;
      font-size: 18px;
      color: #000000;
      line-height: 24px;
      >a{
        margin-left: 12px;
      }
    }
    >.list-box{
      margin-top: 44px;
      width: 1280px;
      display: flex;
      flex-wrap: wrap;
      >.card{
        width: 410px;
        padding: 24px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border: 1px solid #E8E8E8;
        cursor: pointer;
        >:first-child{
          .title{
            font-weight: 400;
            font-size: 16px;
            color: #262600;
            line-height: 24px;
            margin-bottom: 16px;
            >img{
              margin-left: 8px;
            }
          }
          >.tags{
            margin-bottom: 12px;
            height: 24px;
            >span{
              display: inline-block;
              max-width: 100px;
              font-weight: 400;
              font-size: 12px;
              color: #666666;
              line-height: 16px;
              padding: 4px 8px;
              border: 1px solid #E8E8E8;
            }
            >:not(:last-child){
              margin-right: 8px;
            }
            >p{
              font-weight: 400;
              font-size: 12px;
              color: #666666;
              line-height: 20px;
            }
          }
        }
      /*  >:last-child{
          font-weight: 400;
          font-size: 18px;
          color: #EA0B06;
          line-height: 24px;
          >span{
            font-weight: 400;
            font-size: 12px;
            color: #8C8C8C;
            line-height: 17px;
            margin-left: 4px;
          }
        }*/
      }
      >:not(:nth-child(3n)){
        margin-right: 24px;
      }
      >:nth-child(-n+3){
        margin-bottom: 24px;
      }
    }
  }
}
</style>
